export default __webpack_public_path__ + "static/media/eyeBlue.550805a8.svg";